<template>
  <section class="calls-settings-section">
    <ol class="breadcrumb">
      <li class="active">
        <b>{{ title }}</b>
      </li>
    </ol>
    <div class="calls-settings-section-body">
      <div class="col-sm-12">
        <slot></slot>
      </div>
    </div>
    <div class="clearfix"></div>
  </section>
</template>

<script>
export default {
  name: "VideoSettingsSection",
  props: {
    title: {
      type: String,
      required: true
    }
  }
};
</script>

<style>
.calls-settings-section {
  margin-bottom: 10px;
}
.calls-settings-section .breadcrumb {
  margin-bottom: 5px;
  border-radius: 0;
}
.calls-settings-section .calls-settings-section-body {
  padding: 5px 15px;
}
</style>
